<div class="table-responsive m-t-30" [ngClass]="{ 'oculto': dataSource.data.length<1 }">
    <table
        mat-table
        [dataSource]="dataSource"
        class="w-100"
        matSort
        matSortDirection="asc"
    >
        <ng-container matColumnDef="cesionarioName">
            <th
              mat-header-cell
              mat-sort-header
              *matHeaderCellDef
              class="th-title"
            >
              Cliente
            </th>
            <td mat-cell *matCellDef="let element" class="td-text-content">
              <span>
                {{ element.cesionarioName }}
              </span> <br >
              <span>
                {{ element.cesionarioRut }}
              </span>
            </td>
        </ng-container>
  
        <ng-container matColumnDef="transferedInvoiceTotalAmount">
            <th
              mat-sort-header
              mat-header-cell
              *matHeaderCellDef
              class="th-title"
            >
              Monto Facturas
            </th>
            <td mat-cell *matCellDef="let element" class="td-text-content">
              <span>${{ element.transferedInvoiceTotalAmount | number }}</span>
            </td>
        </ng-container>
  
        <ng-container matColumnDef="numTransferedInvoices">
            <th
              mat-sort-header
              mat-header-cell
              *matHeaderCellDef
              class="th-title"
            >
              Documentos
            </th>
            <td mat-cell *matCellDef="let element" class="td-text-content">
              <span>{{ element.numTransferedInvoices }}</span>
            </td>
        </ng-container>
  
        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row class="cursor_table" *matRowDef="let row; columns: displayedColumns"></tr>
  
    </table>
</div>

<div *ngIf="dataSource.data.length<1">
  No se encontraron Factorizaciones
</div>